import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { CookieService } from 'src/app/Services/Global/Cookies/cookie.service';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { GeneralRoleCDMS, typeRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import Swal from 'sweetalert2';

interface ReportLibraryMenu {
  name: string;
  slug: string;
  roles: typeRoleCDMS[];
}

@Component({
    selector: 'app-dashboard-admin',
    templateUrl: './dashboard-admin.component.html',
    styleUrls: ['./dashboard-admin.component.scss', '../../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class DashboardAdminComponent implements OnInit {

  //+================== VARIABLE LENGUAJE ==================+\\
  public Selected: string = '';

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;
  public ReportLibraries: ReportLibraryMenu[] = [
    {
      name: 'Processes',
      slug: 'fin',
      roles: [this.RolesGeneral.AdministratorFIN, this.RolesGeneral.ReportsFIN]
    }
  ];

  //+================== SERIVICES ==================+\\
  private CookieService = inject(CookieService);
  public UserService = inject(UserDataService);
  private MasterLibraryService = inject(LibraryMasterService);
  private router = inject(Router);
  public isLoadingLogout: boolean = false;
  public isSidebarOpen: boolean = false;
  public isUserMenuOpen: boolean = false;


  ngOnInit(): void {
    this.LoadDynamicReportLibraries();
  }

  private async LoadDynamicReportLibraries(): Promise<void> {
    try {
      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_Active_Libraries());
      if (!res.success) {
        return;
      }

      const staticSlugs = ['processes', 'fin', 'ccp'];

      for (const lib of res.operation || []) {
        const slug = String(lib?.Slug || '').toLowerCase();
        const slugUpper = String(lib?.Slug || '').toUpperCase();
        const name = String(lib?.Nombre || slugUpper);

        if (!slug || staticSlugs.includes(slug)) {
          continue;
        }

        const administratorRole = `Administrator${slugUpper}` as typeRoleCDMS;
        const reportRole = `Reports${slugUpper}` as typeRoleCDMS;
        const exists = this.ReportLibraries.some(item => item.slug === slug);

        if (!exists) {
          this.ReportLibraries.push({
            name,
            slug,
            roles: [administratorRole, reportRole]
          });
        }
      }
    } catch (e) {
      console.error('Error loading dashboard report libraries', e);
    }
  }


  public ActiveSideBar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  public ToggleMenuUser(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  public CloseAllMenus(): void {
    this.isSidebarOpen = false;
    this.isUserMenuOpen = false;
  }

  public ActiveMenuUser(CloseOrOpen: boolean): void {
    this.isUserMenuOpen = CloseOrOpen;
  }

  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";

    return Name_User.length > 29 ? Name_User.slice(0, 30) + '...' : Name_User;
  }

  public CloseSession(): void {



    Swal.fire({
      title: '¿Desea cerrar la sesión?',
      text: `La sesión se cerrará completamente`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, cerrar!',
      cancelButtonText: 'No, cancelar',
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {
          this.isLoadingLogout = true;

          setTimeout(() => {
            this.CookieService.deleteCookie('Token_COMPAS');
            this.CookieService.deleteCookie('Data_User_COMPAS');
            localStorage.clear();
            window.location.href = '/LoginCDMS/Home';
          }, 1000);


        } catch (e) {
          this.isLoadingLogout = true;

          setTimeout(() => {
            this.CookieService.deleteCookie('Token_COMPAS');
            this.CookieService.deleteCookie('Data_User_COMPAS');
            localStorage.clear();
            window.location.href = '/LoginCDMS/Home';
          }, 3000);
        }

      }
    })

  }

}
